import { render, staticRenderFns } from "./PlanFactIcon.vue?vue&type=template&id=52d6ae6e"
import script from "./PlanFactIcon.vue?vue&type=script&lang=js"
export * from "./PlanFactIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports